export default "__VITE_ASSET__7e1048b3__"